import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useEffect } from "react";

import { Drawer } from "scmp-app/components/common/drawer";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import { useCurrentArticleIds } from "scmp-app/lib/current-item/hooks";
import { rosettaAtom } from "scmp-app/lib/rosetta";
import { ZIndexLayer } from "scmp-app/lib/styles";

import { StyledSubscriptionWidget } from "./styles";

export const PostiesPaywallContainer: FunctionComponent = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const { currentArticleId } = useCurrentArticleIds();
  const shouldShowPaywall =
    asyncRosettaState?.status === "success" &&
    !asyncRosettaState?.result?.posties?.disablePaywall &&
    !asyncRosettaState?.result?.hasPostiesAccessRight &&
    asyncRosettaState?.result?.contentServiceUserInfo?.isSubscriptionEnabled === true;

  useEffect(() => {
    if (!shouldShowPaywall) return;

    sendGA4Tracking({
      action: "imp",
      category: "subs",
      customized_parameters: {
        article_id: currentArticleId,
        call_to_action: "subscribe",
        paywall_status: "hard",
        trigger_point: "posties paywall",
      },
      subcategory: "entry_point",
    });
  }, [shouldShowPaywall, currentArticleId]);

  if (!shouldShowPaywall) {
    return null;
  }

  return (
    <Drawer
      anchor="bottom"
      open={true}
      PaperProps={{
        sx: {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        },
      }}
      sx={{
        zIndex: `${ZIndexLayer.AppBar - 1}`,
      }}
    >
      <StyledSubscriptionWidget variant="paywall" />
    </Drawer>
  );
};

PostiesPaywallContainer.displayName = "PostiesPaywallContainer";
